import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Global axios config — send cookies with all requests
axios.defaults.withCredentials = true;

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.1,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
